"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathSpan = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
require("mathlive");
require("mathlive/fonts.css");
require("mathlive/static.css");
const equationSelectedClass = (0, nano_theme_1.rule)({
    '&::part(render)': {
        bg: 'var(--selection-color-blurred)',
        bdrad: '2px',
    },
});
const equationFocusedClass = (0, nano_theme_1.rule)({
    '&::part(render)': {
        bg: 'var(--selection-color)',
        bdrad: '2px',
    },
});
const MathSpan = ({ tex, mode = 'textstyle', focused, selected, dark, style, ...props }) => {
    const ref = React.useRef(null);
    if (ref.current && ref.current.textContent !== tex) {
        ref.current.textContent = tex;
        try {
            ref.current.render?.();
        }
        catch { }
    }
    const themedStyle = {
        color: 'inherit',
        colorScheme: dark ? 'dark' : 'light',
        ...style,
    };
    return React.createElement('math-span', {
        ...props,
        ref,
        mode,
        style: themedStyle,
        className: selected ? (focused ? equationFocusedClass : equationSelectedClass) : '',
    }, tex);
};
exports.MathSpan = MathSpan;
